import { getSelectedHouseId } from './getSelectedHouseId';
import { IApplicationState } from '../../types/redux';
import { getHouses } from '../newbuilding';

export function isHouseNameVisible(state: IApplicationState) {
  return getHouses(state).length > 1 && !getSelectedHouseId(state);
}
